import { relationshipModel, UserRole } from "../models";
export let Intent = /*#__PURE__*/function (Intent) {
  Intent["AddPaymentMethod"] = "addPaymentMethod";
  Intent["OpenAccountantAccessRequest"] = "openAccountantAccessRequest";
  Intent["AccountingMapServices"] = "accountingMapServices";
  Intent["AccountingSetupMapContacts"] = "accountingSetupMapContacts";
  Intent["InvoiceApprovePayment"] = "invoiceApprovePayment";
  Intent["InvoiceResolvePayment"] = "invoiceResolvePayment";
  Intent["InvoiceStopPayment"] = "invoiceStopPayment";
  Intent["InvoicePayNow"] = "invoicePayNow";
  Intent["InvoiceResumePayment"] = "invoiceResumePayment";
  Intent["ApproveCharge"] = "approveCharge";
  Intent["InviteTeamMember"] = "inviteTeamMember";
  Intent["RemoveAccountAccess"] = "removeAccountAccess";
  Intent["DeclineAutoApproval"] = "declineAutoApproval";
  Intent["ApproveAllAmendments"] = "approveAllAmendments";
  Intent["InvoiceRejectPaymentExtension"] = "invoiceRejectPaymentExtension";
  Intent["InvoiceApprovePaymentExtension"] = "invoiceApprovePaymentExtension";
  Intent["InvoiceRetryCharge"] = "invoiceRetryCharge";
  Intent["ApproveAllBar"] = "approveAllBar";
  Intent["SelectPackage"] = "selectPackage";
  Intent["DownloadAgreementPdf"] = "downloadAgreementPdf";
  Intent["DuplicateAgreement"] = "duplicateAgreement";
  Intent["CopyRelationshipDirectLink"] = "copyRelationshipDirectLink";
  Intent["TerminateAgreement"] = "terminateAgreement";
  Intent["SendProposal"] = "sendProposal";
  Intent["SendProposalReminder"] = "sendProposalReminder";
  Intent["EditProposal"] = "editProposal";
  Intent["DuplicateProposal"] = "duplicateProposal";
  Intent["CancelProposal"] = "cancelProposal";
  Intent["InvoiceMarkPaidExternally"] = "invoiceMarkPaidExternally";
  Intent["InvoiceResend"] = "invoiceResend";
  Intent["InvoiceDownload"] = "invoiceDownload";
  Intent["InvoiceVoid"] = "invoiceVoid";
  Intent["InvoiceCopyLink"] = "invoiceCopyLink";
  Intent["UpdateBusinessDetails"] = "updateBusinessDetails";
  Intent["ChangeRole"] = "changeRole";
  Intent["ResendMemberInvitation"] = "resendMemberInvitation";
  Intent["RemoveFromTeam"] = "removeFromTeam";
  Intent["UpdateProfile"] = "updateProfile";
  Intent["OpenHelpMenu"] = "openHelpMenu";
  Intent["ApproveProposal"] = "approveProposal";
  Intent["ProposalSwitchCompany"] = "proposalSwitchCompany";
  Intent["AccountingMapAccounts"] = "accountingMapAccounts";
  Intent["AccountingDisconnect"] = "accountingDisconnect";
  Intent["ClientViewProposal"] = "clientViewProposal";
  Intent["VendorViewProposal"] = "vendorViewProposal";
  Intent["CreateProposalTemplate"] = "createProposalTemplate";
  Intent["EditProposalTemplate"] = "editProposalTemplate";
  Intent["ViewProposalTemplate"] = "viewProposalTemplate";
  Intent["UseProposalTemplate"] = "useProposalTemplate";
  Intent["RenameProposalTemplate"] = "renameProposalTemplate";
  Intent["RemoveProposalTemplate"] = "removeProposalTemplate";
  Intent["DiscardDraft"] = "discardDraft";
  Intent["AddCharge"] = "addCharge";
  Intent["AddCredit"] = "addCredit";
  Intent["RemoveCredit"] = "removeCredit";
  Intent["Bill"] = "bill";
  Intent["RemoveCharge"] = "removeCharge";
  Intent["EnterAccountantAccess"] = "enterAccountantAccess";
  Intent["ClientCreateVendorAccount"] = "clientCreateVendorAccount";
  Intent["RequestRefund"] = "requestRefund";
  Intent["SelectOptionalService"] = "selectOptionalService";
  Intent["ExportAgreementsToCsv"] = "exportAgreementsToCsv";
  Intent["BrandSetup"] = "brandSetup";
  Intent["CreateServiceTemplate"] = "createServiceTemplate";
  return Intent;
}({});
const forbiddenTooltipText = "You don't have permission to perform this action. Contact the account owner to grant you access.";
const openToAll = new Set([UserRole.Accountant, UserRole.Admin, UserRole.Member, UserRole.Owner, UserRole.AnchorAdmin, UserRole.Reviewer]);
const openToOwnerAdminAndAnchorAdmin = new Set([UserRole.Admin, UserRole.Owner, UserRole.AnchorAdmin]);
const openToAllExceptMembersAndReviewers = new Set([UserRole.Owner, UserRole.Admin, UserRole.Accountant, UserRole.AnchorAdmin]);
const openToAllExceptAccountantAndReviewer = new Set([UserRole.Owner, UserRole.Admin, UserRole.Member, UserRole.AnchorAdmin]);
const openToAllExceptAnchorAdminAndReviewer = new Set([UserRole.Owner, UserRole.Admin, UserRole.Member, UserRole.Accountant]);
const openToOwnerAndAdmin = new Set([UserRole.Admin, UserRole.Owner]);
const openToOwnerAdminAndMember = new Set([UserRole.Owner, UserRole.Admin, UserRole.Member]);
const openToAllExpectAnchorAdminAndAccountant = new Set([UserRole.Owner, UserRole.Admin, UserRole.Member, UserRole.Reviewer]);
const openToAdminAndMember = new Set([UserRole.Admin, UserRole.Member]);
const accessControlAllowList = {
  [Intent.AddPaymentMethod]: openToAll,
  [Intent.OpenAccountantAccessRequest]: openToOwnerAdminAndAnchorAdmin,
  [Intent.AccountingMapServices]: openToOwnerAdminAndAnchorAdmin,
  [Intent.AccountingSetupMapContacts]: openToOwnerAdminAndAnchorAdmin,
  [Intent.AccountingMapAccounts]: openToAllExceptAccountantAndReviewer,
  [Intent.AccountingDisconnect]: openToAllExceptAccountantAndReviewer,
  [Intent.InvoiceApprovePayment]: openToOwnerAdminAndAnchorAdmin,
  [Intent.InvoiceResolvePayment]: openToOwnerAdminAndAnchorAdmin,
  [Intent.InvoiceStopPayment]: openToOwnerAndAdmin,
  [Intent.InvoicePayNow]: openToOwnerAdminAndAnchorAdmin,
  [Intent.InvoiceResumePayment]: openToOwnerAdminAndAnchorAdmin,
  [Intent.ApproveCharge]: openToOwnerAndAdmin,
  [Intent.InviteTeamMember]: openToOwnerAdminAndAnchorAdmin,
  [Intent.RemoveAccountAccess]: openToOwnerAdminAndAnchorAdmin,
  [Intent.DeclineAutoApproval]: openToOwnerAdminAndAnchorAdmin,
  [Intent.ApproveAllAmendments]: openToOwnerAdminAndAnchorAdmin,
  [Intent.InvoiceRejectPaymentExtension]: openToOwnerAdminAndAnchorAdmin,
  [Intent.InvoiceApprovePaymentExtension]: openToOwnerAdminAndAnchorAdmin,
  [Intent.InvoiceRetryCharge]: openToOwnerAndAdmin,
  [Intent.ApproveAllBar]: openToOwnerAndAdmin,
  [Intent.SelectPackage]: openToOwnerAdminAndAnchorAdmin,
  [Intent.RemoveFromTeam]: openToOwnerAdminAndAnchorAdmin,
  [Intent.DuplicateAgreement]: openToAllExceptAccountantAndReviewer,
  [Intent.TerminateAgreement]: openToAllExceptAccountantAndReviewer,
  [Intent.SendProposal]: openToAllExceptAnchorAdminAndReviewer,
  [Intent.SendProposalReminder]: openToAllExceptAccountantAndReviewer,
  [Intent.EditProposal]: openToAllExceptAccountantAndReviewer,
  [Intent.DuplicateProposal]: openToAllExceptAccountantAndReviewer,
  [Intent.CancelProposal]: openToAllExceptAccountantAndReviewer,
  [Intent.InvoiceMarkPaidExternally]: openToOwnerAdminAndMember,
  [Intent.InvoiceResend]: openToAllExceptAccountantAndReviewer,
  [Intent.InvoiceDownload]: openToAll,
  [Intent.InvoiceVoid]: openToOwnerAdminAndMember,
  [Intent.InvoiceCopyLink]: openToAll,
  [Intent.UpdateBusinessDetails]: openToAllExceptAccountantAndReviewer,
  [Intent.ChangeRole]: openToAllExceptAccountantAndReviewer,
  [Intent.ResendMemberInvitation]: openToAllExceptAccountantAndReviewer,
  [Intent.UpdateProfile]: openToAll,
  [Intent.OpenHelpMenu]: openToAllExceptAccountantAndReviewer,
  [Intent.ApproveProposal]: openToAdminAndMember,
  [Intent.ProposalSwitchCompany]: openToAllExceptAccountantAndReviewer,
  [Intent.DownloadAgreementPdf]: openToAll,
  [Intent.CopyRelationshipDirectLink]: openToAll,
  [Intent.ClientViewProposal]: openToAllExceptAccountantAndReviewer,
  [Intent.VendorViewProposal]: openToAll,
  [Intent.CreateProposalTemplate]: openToAllExceptMembersAndReviewers,
  [Intent.EditProposalTemplate]: openToAllExceptMembersAndReviewers,
  [Intent.ViewProposalTemplate]: openToAll,
  [Intent.UseProposalTemplate]: openToAll,
  [Intent.RenameProposalTemplate]: openToAllExceptMembersAndReviewers,
  [Intent.RemoveProposalTemplate]: openToAllExceptMembersAndReviewers,
  [Intent.DiscardDraft]: openToAll,
  [Intent.AddCharge]: openToAllExceptAnchorAdminAndReviewer,
  [Intent.AddCredit]: openToAllExceptAnchorAdminAndReviewer,
  [Intent.RemoveCredit]: openToAllExceptAnchorAdminAndReviewer,
  [Intent.Bill]: openToAllExceptAnchorAdminAndReviewer,
  [Intent.RemoveCharge]: openToAllExceptAnchorAdminAndReviewer,
  [Intent.EnterAccountantAccess]: openToAllExceptAnchorAdminAndReviewer,
  [Intent.ClientCreateVendorAccount]: openToAllExpectAnchorAdminAndAccountant,
  [Intent.RequestRefund]: openToOwnerAdminAndAnchorAdmin,
  [Intent.SelectOptionalService]: openToOwnerAdminAndAnchorAdmin,
  [Intent.ExportAgreementsToCsv]: openToOwnerAdminAndAnchorAdmin,
  [Intent.BrandSetup]: openToOwnerAdminAndAnchorAdmin,
  [Intent.CreateServiceTemplate]: openToOwnerAdminAndAnchorAdmin
};
function getForbiddenTooltipText(intent, primaryName) {
  switch (intent) {
    case Intent.SelectOptionalService:
      return "Only ".concat(primaryName || 'primary recipient', " can select optional services");
    case Intent.SelectPackage:
      return "Only ".concat(primaryName, " can select package for this proposal");
    default:
      return forbiddenTooltipText;
  }
}
export function getIntentBehavior(userRole) {
  var _opts$relationshipSta, _opts$relationshipSta2;
  let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const isSignatory = ((_opts$relationshipSta = opts.relationshipState) === null || _opts$relationshipSta === void 0 ? void 0 : _opts$relationshipSta.relationship) && opts.userId && relationshipModel.isSignatory(opts.relationshipState.relationship, opts.userId);
  const primaryName = (_opts$relationshipSta2 = opts.relationshipState) !== null && _opts$relationshipSta2 !== void 0 && _opts$relationshipSta2.relationship ? relationshipModel.buyerFullName(opts.relationshipState.relationship) : undefined;

  // eslint-disable-next-line no-console
  const warn = intent => console.warn('[access-control] unrecognized intent:', intent);
  const isAllowed = intent => {
    var _opts$relationshipSta3, _opts$relationshipSta4, _opts$relationshipSta5;
    const isOwnerWithoutSignatories = ((_opts$relationshipSta3 = opts.relationshipState) === null || _opts$relationshipSta3 === void 0 ? void 0 : _opts$relationshipSta3.relationship) && UserRole.Owner === userRole && !relationshipModel.hasSignatories(opts.relationshipState.relationship);
    const isBuyer = ((_opts$relationshipSta4 = opts.relationshipState) === null || _opts$relationshipSta4 === void 0 ? void 0 : _opts$relationshipSta4.relationship) && relationshipModel.isBuyer(opts.relationshipState.relationship, opts.userId);
    if (intent === Intent.ApproveProposal && (isSignatory || isOwnerWithoutSignatories || isBuyer)) {
      return true;
    }
    if (intent === Intent.SelectPackage && (_opts$relationshipSta5 = opts.relationshipState) !== null && _opts$relationshipSta5 !== void 0 && _opts$relationshipSta5.isPreviewMode) return true;
    const allowList = accessControlAllowList[intent];
    if (!allowList) {
      warn(intent);
      return true;
    }
    return allowList.has(userRole);
  };
  return {
    getDisabled(intent) {
      if (!userRole) return false;
      return !isAllowed(intent);
    },
    getTooltip(intent) {
      if (!userRole) return null;
      return isAllowed(intent) ? null : getForbiddenTooltipText(intent, primaryName);
    }
  };
}